import React, {useEffect, useReducer} from "react";
import Box from "@amzn/meridian/box";
import {PrintSheetReducer} from "./reducers/PrintSheetReducer";
import Row from "@amzn/meridian/row";
import Alert from "@amzn/meridian/alert";

const initialState = {
    isSuccess: true
};

/* Shows scannable id and their success/failure status
*  after performing change assigned station operation
* */
export const TransferSheetResponse = ({checkedPackages}) => {
    const [{isSuccess}, casDispatch] = useReducer(PrintSheetReducer, initialState);

    useEffect(() => {
        casDispatch({
            type: "PRINT_TRANSFER_SHEET",
            data: {
                scannableIds: checkedPackages,
                dispatcher: casDispatch
            }
        })
    }, []);

    if (!isSuccess) {
        return (
            <Row alignmentHorizontal="center" alignmentVertical="center">
                <Alert type="error">Error</Alert>
            </Row>
        );
    }
    return (<Box></Box>

    );
};


// WEBPACK FOOTER //
// ./src/components/transferSheet/TransferSheetResponse.js